var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 41,
    viewBox: "0 0 29 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5002 0C7.32858 0 0.833496 5.81346 0.833496 12.9868C0.833496 20.1583 6.7597 28.7205 14.5002 41C22.2406 28.7205 28.1668 20.1583 28.1668 12.9868C28.1668 5.81346 21.6735 0 14.5002 0ZM14.5002 18.7917C11.6695 18.7917 9.37516 16.4974 9.37516 13.6667C9.37516 10.836 11.6695 8.54167 14.5002 8.54167C17.3309 8.54167 19.6252 10.836 19.6252 13.6667C19.6252 16.4974 17.3309 18.7917 14.5002 18.7917Z",
    fill: "#1E8E06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerCompleted);
export default __webpack_public_path__ + "static/media/map_marker_completed.89031eac35f5ab2ca23337ab2a9881a2.svg";
export { ForwardRef as ReactComponent };